const { REACT_APP_API_URL = '' } = process.env

export const NAMESPACE = 'documents'

export const ENDPOINTS = {
  FETCH_DOCUMENTS: `${REACT_APP_API_URL}/document/class/:className/:classId`,
  FETCH_DOCUMENT_TAGS: `${REACT_APP_API_URL}/document/:documentId/tags`,
  DOWNLOAD_DOCUMENT: `${REACT_APP_API_URL}/document/:documentId/download`,
  REMOVE_DOCUMENT: `${REACT_APP_API_URL}/document/:documentId`,
  RENAME_DOCUMENT: `${REACT_APP_API_URL}/document/:documentId/rename`,
  UPDATE_DOCUMENT_TAGS: `${REACT_APP_API_URL}/document/:documentId/tags`,
}
